module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAbUExURZqKeZqKeZqKeZqKeZqKeZqKeZqKeZqKeZqKeZZ5gNcAAAAJdFJOUwL/F8xAcN4oswRkZT0AAAAJcEhZcwAAAEgAAABIAEbJaz4AAACBSURBVBjTY2BgNRQEA+EABgYmKBvIU2BgFoQDA4ZABEeUwRDBEWYQRALYOWIObgiOCAMLmCOh1CgoKMTAAOYIMSiCCIiMAAOroFg5VE+QUriSkiPYtBR2ZUFBBSaI0Q4MjgiOAgOjoGCTBpIMzAUpLInY3YbiBRTPoXgbJUCQgwoA8QMY75KFyM4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/school/dfr.png
// module id = 216
// module chunks = 0